export default () => {
  let $ = jQuery

  $('body').on('click', '.load-more', function () {
    let max_num_pages = Number($('#max_num_pages').val())

    $.ajax({
      url: window.ajax_.ajax_url,
      type: 'get',
      data: {
        action: 'postsLoadMore',
        posts_per_page: Number($('#posts_per_page').val()),
        loaded_page_number: Number($('#loaded_page_number').val()),
        category_id: Number($('.category-tabs .tab.active').data('category')),
      },
      beforeSend: function () {
        $('.load-more').text('Loading...')
      },
      success: function (response) {
        setTimeout(function () {
          let loaded_page_number = response.data.loaded_page_number
          $('#loaded_page_number').val(loaded_page_number)

          $('.card:last').appendTo(response.data.html).show().fadeIn('slow')

          if (loaded_page_number == max_num_pages) {
            $('.load-more').remove()
          } else {
            $('.load-more').text('Show more')
          }
        }, 2000)
      },
    })
  })
}
